import { render } from "./theme1.vue?vue&type=template&id=5a53d71e&scoped=true"
import script from "./theme1.vue?vue&type=script&lang=js"
export * from "./theme1.vue?vue&type=script&lang=js"

import "./theme1.vue?vue&type=style&index=0&id=5a53d71e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5a53d71e"

export default script